const state = {
  selectSchoolList: [],
  schoolSelect: '',
  schoolSelectName: '',
  buildingIds: [],
  initSwitchingSchoolFlag: false
}

const mutations = {
  setSelectSchoolList (state, selectSchoolList) {
    state.selectSchoolList = selectSchoolList
  },
  setSchoolSelect (state, schoolSelect) {
    state.schoolSelect = schoolSelect
  },
  setSchoolSelectName (state, schoolSelectName) {
    state.schoolSelectName = schoolSelectName
  },
  setBuildingIds (state, buildingIds) {
    state.buildingIds = buildingIds
  },
  setInitSwitchingSchoolFlag (state, initSwitchingSchoolFlag) {
    state.initSwitchingSchoolFlag = initSwitchingSchoolFlag
  }
}

const actions = {

}

const getters = {
  selectSchoolList (state) {
    return state.selectSchoolList
  },
  schoolSelect (state) {
    return state.schoolSelect
  },
  schoolSelectName (state) {
    return state.schoolSelectName
  },
  buildingIds (state) {
    return state.buildingIds
  },
  initSwitchingSchoolFlag (state) {
    return state.initSwitchingSchoolFlag
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}